import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {MarketingColors} from "./constants.ts";
import * as mediaQueries from "./media-queries.ts";

const DESKTOP_BLOB =
    "M1366 614.626V42.2878C1216.44 32.481 1071.16 25.6274 902.892 20.0618C647.674 11.6203 291.457 3.37253 0 0.135254V612.111C313.572 631.987 694.403 637.367 1189.78 619.86C1248.63 617.783 1307.48 616.071 1366 614.626Z";

const MOBILE_BLOB =
    "M0 9.68462V617.774C147.168 622.024 270.083 621.875 376 618.496V0C260.308 0 77.1282 6.45641 0 9.68462Z";

export const backgroundBlobDesktopHeight = 631;
export const backgroundBlobMobileHeight = 621;

export const BackgroundBlob = (): React.ReactElement => (
    <>
        <svg
            viewBox="0 0 1366 631"
            height={backgroundBlobDesktopHeight}
            className={css(styles.background, styles.desktopOnly)}
            preserveAspectRatio="none"
            aria-hidden="true"
        >
            <path d={DESKTOP_BLOB} fill={MarketingColors.lightTan} />
        </svg>
        <svg
            viewBox="0 0 376 621"
            height={backgroundBlobMobileHeight}
            className={css(styles.background, styles.tabletAndSmaller)}
            preserveAspectRatio="none"
            aria-hidden="true"
        >
            <path d={MOBILE_BLOB} fill={MarketingColors.lightTan} />
        </svg>
    </>
);

const styles = StyleSheet.create({
    background: {
        position: "absolute",
        width: "100%",
        overflow: "visible",
        zIndex: -1,
        top: 0,
        alignSelf: "center",
        minHeight: "100%",
        [mediaQueries.smallDesktopOrSmaller]: {
            height: "100%",
            top: 0,
            bottom: 0,
        },
    },
    desktopOnly: {
        display: "none",
        [mediaQueries.desktopOrLarger]: {
            display: "block",
        },
    },
    tabletAndSmaller: {
        display: "block",
        [mediaQueries.desktopOrLarger]: {
            display: "none",
        },
    },
});
